import { Dispatch } from 'redux';
import {
  InquiryListResponse,
  getInquiryList,
  getUnreadCount,
  UnrespondedMessagesResponse,
} from '../client/v1/inquiry';
import * as ActionType from './types/InquiryActionTypes';

export function requestUnreadCount(): ActionType.InquiryUnrespondedMessagesActionTypes {
  return {
    type: ActionType.REQUEST_UNRESPONDED_MESSAGE_COUNT,
  };
}

export function receiveUnreadCount(
  response: UnrespondedMessagesResponse
): ActionType.InquiryUnrespondedMessagesActionTypes {
  return {
    type: ActionType.RECIEVED_UNRESPONDED_MESSAGE_COUNT,
    payload: response.unreadTotal,
  };
}
export function requestInquiryList(): ActionType.InquiryUnrespondedMessagesActionTypes {
  return {
    type: ActionType.REQUEST_UNRESPONDED_MESSAGE_COUNT,
  };
}

export function receiveInquiryList(
  response: InquiryListResponse
): ActionType.InquiryUnrespondedMessagesActionTypes {
  return {
    type: ActionType.RECIEVED_INQUIRY_LIST,
    payload: {
      inquiries: response.entities,
    },
  };
}

export function fetchUnrespondedMessages() {
  return (
    dispatch: Dispatch<ActionType.InquiryUnrespondedMessagesActionTypes>
  ): Promise<unknown> => {
    dispatch(requestUnreadCount());
    return getUnreadCount()
      .then((response: UnrespondedMessagesResponse) => {
        dispatch(receiveUnreadCount(response));
        return response;
      })
      .catch((error: Error) => {
        throw error;
      });
  };
}

export function fetchInquiryList() {
  return (
    dispatch: Dispatch<ActionType.InquiryUnrespondedMessagesActionTypes>
  ): Promise<unknown> => {
    dispatch(requestInquiryList());
    return getInquiryList()
      .then((response: InquiryListResponse) => {
        dispatch(receiveInquiryList(response));
        return response;
      })
      .catch((error: Error) => {
        throw error;
      });
  };
}
